const AUTH_STATE = {
  uninitialized: null,
  loggedIn: true,
  loggedOut: false,
};

export default AUTH_STATE;
